import React, { useState, useEffect, useMemo } from "react";
import $ from "jquery";
import SupplierSuggestionList from "./SupplierSuggestionList";
import BoxPricingTable from "./BoxPricingTable";
import PiecePricingTable from "./PiecePricingTable";
import DynamicProductFormFields from "./DynamicProductFormFields";
import {
  fetchDynamicForm,
  isSectionVisible,
  loadProductFormOptionsMap,
  PRODUCT_TYPE_TO_SPLIT,
  resolveProductFormFieldName,
} from "./dynamicFormApi";
import {
  mergePriceTierVisibleMap,
  resolvePriceTierMapFromField,
} from "../../Settings/productFormSubFieldUtils";
import {
  pricingModeStorageKey,
  resolvePricingModeSelection,
  resolveProductSettingsFieldName,
} from "../../Settings/productFormFieldDefaults";
import config from "../../common/Config";
import QuickBooksPushPrompt from "../../common/QuickBooksPushPrompt";
import axios from "axios";
import { Box, Typography, TextField, Button, Paper, Grid2, Radio, RadioGroup,FormLabel, FormControlLabel, FormControl, Checkbox, IconButton, Autocomplete, Select, MenuItem, InputLabel } from '@mui/material';
import { toast } from 'sonner';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { format } from 'date-fns';
import "../../common/commonStyles.css";
import { Iconify } from '../../Minimal/src/components/iconify/iconify';
import { encryptPayload, normalizeEncryptedApiResponse, plainObjectFromFormData } from "../../../utils/customerCrypto";
import { getCompanySettings, resolveCustomerApiEncrypt } from "../../../utils/companySettingsCache";
import { postGetPriceVariation } from "../../../utils/priceVariationApi";

const computeCbmFromDimensions = (length, width, height, lengthUnit, widthUnit, heightUnit) => {
  const unitConversionToMM = { mm: 1, cm: 10, in: 25.4, m: 1000 };
  const parseDim = (v) => {
    const n = parseFloat(String(v ?? '').trim().replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
  };
  const w = parseDim(width);
  const h = parseDim(height);
  const l = parseDim(length);
  if (!Number.isFinite(w) || !Number.isFinite(h) || !Number.isFinite(l)) {
    return '0';
  }
  const lf = unitConversionToMM[lengthUnit || 'mm'] || 1;
  const wf = unitConversionToMM[widthUnit || 'mm'] || 1;
  const hf = unitConversionToMM[heightUnit || 'mm'] || 1;
  const cbm = (l * lf * w * wf * h * hf) / 1e9;
  if (!Number.isFinite(cbm)) return '0';
  if (cbm === 0) return '0';
  const s =
    Math.abs(cbm) < 0.0001
      ? String(parseFloat(cbm.toFixed(6)))
      : String(parseFloat(cbm.toFixed(4)));
  return s;
};

const Add_Products = ({ useDynamicForm = false }) => {
  const accessToken = localStorage.getItem("accessToken");
  const jwtToken = localStorage.getItem("token");
  const company_tax_type = localStorage.getItem("company_tax_type");
  const showCessRate = localStorage.getItem("showCessRate");
  const userId = localStorage.getItem("userId");
  const isAtrPrefix = accessToken === "atr" || config.PREFIX === "atr";
  const [qbPromptOpen, setQbPromptOpen] = useState(false);
  const [selectSupplierAllowed, setSelectSupplierAllowed] = useState(true);
  const [selectedOption, setSelectedOption] = useState("0");

  const toggleOptions = (option) => {
    setSelectedOption(option);
    setFormData((prev) => ({
      ...prev,
      split: option,
    }));
  };

  const [formData, setFormData] = useState({
    code: "",
    name: "",
    cost: "",
    price: "",
    piece_cost: "",
    recommendedSellingBoxPrice: "",
    recommendedSellingPiecePrice: "",
    inner_ean_number: "",
    outer_ean_number: "",
    pallete_ean: "",
    min_alert_quantity: "",
    max_alert_quantity: "",
    maximum_order_quantity: "",
    details: "",
    product_details: "",
    slug: "",
    hsn_code: "",
    size: "",
    pack: "",
    bay: "",
    rack: "",
    second_name: "",
    split: "",
    split_price: "",
    price_1: "",
    price_2: "",
    price_3: "",
    price_4: "",
    price_5: "",
    piece_price1: "",
    piece_price2: "",
    piece_price3: "",
    piece_price4: "",
    piece_price5: "",
    band1_special_box_price: "",
    band1_special_piece_price: "",
    band2_special_box_price: "",
    band2_special_piece_price: "",
    band3_special_box_price: "",
    band3_special_piece_price: "",
    band4_special_box_price: "",
    band4_special_piece_price: "",
    band5_special_box_price: "",
    band5_special_piece_price: "",
    band6_special_box_price: "",
    band6_special_piece_price: "",
    is_discount_allow: "0",
    availableFor: "0",
    featured: "0",
    percentage: "",
    new_arrival: "0",
    new_arrival_date: "",
    min_shelf_life: "",
    max_shelf_life: "",
    margin: "",
    piece_margin: "",
    unit: "",
    tax_rate: "",
    category: "",
    part_number: "",
  });
  const [errors, setErrors] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [unitOptions, setUnitOptions] = useState([]);
  const [vatOptions, setVatOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [cessOptions, setCessOptions] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedVat, setSelectedVat] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCess, setSelectedCess] = useState(null);
  const [lengthUnit, setLengthUnit] = useState("mm");
  const [widthUnit, setWidthUnit] = useState("mm");
  const [heightUnit, setHeightUnit] = useState("mm");
  const [dynamicFields, setDynamicFields] = useState([]);
  const [dynamicFormMeta, setDynamicFormMeta] = useState(null);
  const [dynamicOptionsBySource, setDynamicOptionsBySource] = useState({});
  const productDetailsFields = useMemo(() => {
    const detailsSection = dynamicFormMeta?.sections?.find(
      (section) => section.id === "product_details"
    );
    return detailsSection?.fields?.length
      ? detailsSection.fields
      : dynamicFields;
  }, [dynamicFormMeta, dynamicFields]);
  const allDynamicFields = useMemo(() => {
    if (dynamicFormMeta?.sections?.length) {
      return dynamicFormMeta.sections.flatMap((section) => section.fields || []);
    }
    return dynamicFields;
  }, [dynamicFormMeta, dynamicFields]);
  const dynamicFormKeys = useMemo(
    () =>
      new Set(
        allDynamicFields.map((field) => resolveProductFormFieldName(field.name))
      ),
    [allDynamicFields]
  );
  const hasDynamicFields = productDetailsFields.length > 0 || allDynamicFields.length > 0;
  const fieldMatchesName = (field, name) => {
    if (!field) return false;
    const key = resolveProductFormFieldName(name);
    const settingsKey = resolveProductSettingsFieldName(name);
    const fieldKey = resolveProductFormFieldName(field.name);
    const fieldSettings = resolveProductSettingsFieldName(field.name);
    return (
      field.name === name ||
      field.name === key ||
      field.name === settingsKey ||
      fieldKey === key ||
      fieldSettings === settingsKey ||
      fieldSettings === name
    );
  };
  const findDynField = (name) => {
    for (const field of allDynamicFields) {
      if (fieldMatchesName(field, name)) return field;
    }
    const matchNested = (field) => {
      for (const nested of field.fields || []) {
        if (fieldMatchesName(nested, name)) return nested;
        const found = matchNested(nested);
        if (found) return found;
      }
      return null;
    };
    for (const field of allDynamicFields) {
      const found = matchNested(field);
      if (found) return found;
    }
    return null;
  };
  const hasDynField = (name) => {
    const field = findDynField(name);
    if (useDynamicForm && field) return field.visible !== false;
    const key = resolveProductFormFieldName(name);
    return dynamicFormKeys.has(key) || !!field;
  };
  const getDynSection = (sectionId) =>
    dynamicFormMeta?.sections?.find((section) => section.id === sectionId) ||
    null;
  const showDynSection = (sectionId) => {
    if (!hasDynamicFields) return true;
    const section = getDynSection(sectionId);
    if (!section) return false;
    if (!(section.fields || []).length) return false;
    return isSectionVisible(section, { ...formData, split: selectedOption });
  };
  const showBoxPricing =
    (selectedOption == "0" || selectedOption == "2") &&
    (!hasDynamicFields ||
      hasDynField("box_cost") ||
      hasDynField("cost") ||
      hasDynField("recommended_selling_price") ||
      hasDynField("recommendedSellingBoxPrice") ||
      hasDynField("price_box") ||
      hasDynField("special_price_box") ||
      hasDynField("box_prices") ||
      hasDynField("box_margin") ||
      hasDynField("margin") ||
      showDynSection("box_pricing"));
  const showPiecePricing =
    (selectedOption == "1" || selectedOption == "2") &&
    (!hasDynamicFields ||
      hasDynField("piece_cost") ||
      hasDynField("piece_recommended_selling_price") ||
      hasDynField("recommendedSellingPiecePrice") ||
      hasDynField("price_piece") ||
      hasDynField("special_price_piece") ||
      hasDynField("piece_prices") ||
      hasDynField("piece_margin") ||
      showDynSection("piece_pricing"));
  const boxPriceSubFields = useMemo(() => {
    if (!useDynamicForm) return null;
    const resolveTierMap = (fieldName, aliases = []) => {
      const field =
        findDynField(fieldName) ||
        aliases.map((alias) => findDynField(alias)).find(Boolean);
      return resolvePriceTierMapFromField(field, fieldName);
    };
    return mergePriceTierVisibleMap(
      resolveTierMap("price_box", ["box_prices", "box_pricing"]),
      resolveTierMap("special_price_box"),
    );
  }, [allDynamicFields, dynamicFormMeta, useDynamicForm]);
  const piecePriceSubFields = useMemo(() => {
    if (!useDynamicForm) return null;
    const resolveTierMap = (fieldName, aliases = []) => {
      const field =
        findDynField(fieldName) ||
        aliases.map((alias) => findDynField(alias)).find(Boolean);
      return resolvePriceTierMapFromField(field, fieldName);
    };
    return mergePriceTierVisibleMap(
      resolveTierMap("price_piece", ["piece_prices", "piece_pricing"]),
      resolveTierMap("special_price_piece"),
    );
  }, [allDynamicFields, dynamicFormMeta, useDynamicForm]);
  const isPricingFieldVisible = (name, aliases = []) => {
    if (!useDynamicForm || !hasDynamicFields) return true;
    const field =
      findDynField(name) ||
      aliases.map((alias) => findDynField(alias)).find(Boolean);
    if (!field) return false;
    return field.visible !== false;
  };
  const pricingFieldVisibility = useDynamicForm
    ? {
        box_cost: isPricingFieldVisible("box_cost", ["cost"]),
        recommended_selling_price: isPricingFieldVisible(
          "recommended_selling_price",
          ["recommendedSellingBoxPrice"],
        ),
        price_box: isPricingFieldVisible("price_box"),
        special_price_box: isPricingFieldVisible("special_price_box"),
        price_piece: isPricingFieldVisible("price_piece"),
        special_price_piece: isPricingFieldVisible("special_price_piece"),
        piece_cost: isPricingFieldVisible("piece_cost"),
        piece_recommended_selling_price: isPricingFieldVisible(
          "piece_recommended_selling_price",
          ["recommendedSellingPiecePrice"],
        ),
        piece_margin: isPricingFieldVisible("piece_margin"),
        box_margin: isPricingFieldVisible("box_margin", ["margin"]),
      }
    : null;
  const activeBoxSubFields = useDynamicForm
    ? { ...boxPriceSubFields, ...pricingFieldVisibility }
    : null;
  const activePieceSubFields = useDynamicForm
    ? { ...piecePriceSubFields, ...pricingFieldVisibility }
    : null;
  const showSelectSupplier = (() => {
    if (!selectSupplierAllowed) return false;
    if (!useDynamicForm) return true;
    if (!hasDynamicFields) return false;
    const supplierFields = allDynamicFields.filter((field) => {
      const rawName = String(field?.name || "");
      const label = String(field?.label || "").toLowerCase();
      return (
        resolveProductSettingsFieldName(rawName) === "suppliers" ||
        rawName.toLowerCase().includes("supplier") ||
        label.includes("supplier")
      );
    });
    if (!supplierFields.length) return false;
    return supplierFields.every((field) => field.visible !== false);
  })();
  const lockedSplit = useMemo(() => {
    if (!useDynamicForm) return "";
    const mode =
      resolvePricingModeSelection(dynamicFormMeta?.pricing_type) ||
      resolvePricingModeSelection(dynamicFormMeta?.product_type) ||
      resolvePricingModeSelection(dynamicFormMeta?.split) ||
      resolvePricingModeSelection(
        (() => {
          try {
            return localStorage.getItem(pricingModeStorageKey("add_product"));
          } catch {
            return "";
          }
        })(),
      );
    if (mode) return PRODUCT_TYPE_TO_SPLIT[mode] || "";
    const boxVisible = !!(
      pricingFieldVisibility?.box_cost ||
      pricingFieldVisibility?.price_box ||
      pricingFieldVisibility?.recommended_selling_price ||
      pricingFieldVisibility?.special_price_box ||
      pricingFieldVisibility?.box_margin
    );
    const pieceVisible = !!(
      pricingFieldVisibility?.piece_cost ||
      pricingFieldVisibility?.price_piece ||
      pricingFieldVisibility?.piece_recommended_selling_price ||
      pricingFieldVisibility?.special_price_piece ||
      pricingFieldVisibility?.piece_margin
    );
    if (boxVisible && !pieceVisible) return "0";
    if (pieceVisible && !boxVisible) return "1";
    return "";
  }, [dynamicFormMeta, pricingFieldVisibility, useDynamicForm]);
  const showBoxTypeOption = !lockedSplit || lockedSplit === "0" || lockedSplit === "2";
  const showPieceTypeOption = !lockedSplit || lockedSplit === "1" || lockedSplit === "2";
  const showBothTypeOption = !lockedSplit || lockedSplit === "2";
  const optionsBySource = useMemo(
    () => ({
      units: dynamicOptionsBySource.units?.length
        ? dynamicOptionsBySource.units
        : unitOptions,
      vat: dynamicOptionsBySource.vat?.length
        ? dynamicOptionsBySource.vat
        : vatOptions,
      brands: dynamicOptionsBySource.brands?.length
        ? dynamicOptionsBySource.brands
        : brandOptions,
      categories: dynamicOptionsBySource.categories?.length
        ? dynamicOptionsBySource.categories
        : categoryOptions,
      cess: dynamicOptionsBySource.cess?.length
        ? dynamicOptionsBySource.cess
        : cessOptions,
      availability: dynamicOptionsBySource.availability?.length
        ? dynamicOptionsBySource.availability
        : [
            { label: "All", value: "0" },
            { label: "TeleCaller", value: "1" },
          ],
      ...dynamicOptionsBySource,
    }),
    [
      unitOptions,
      vatOptions,
      brandOptions,
      categoryOptions,
      cessOptions,
      dynamicOptionsBySource,
    ]
  );

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? "1" : "0",
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const handleUnitChange = (event, newValue) => {
    setSelectedUnit(newValue);
    const value = newValue ? newValue.value : "";
    setFormData((prevData) => ({
      ...prevData,
      unit: value,
    }));
    if (errors.unit) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        unit: "",
      }));
    }
  };

  const handleVatChange = (event, newValue) => {
    setSelectedVat(newValue);
    const value = newValue ? newValue.value : "";
    setFormData((prevData) => ({
      ...prevData,
      tax_rate: value,
    }));
    if (errors.tax_rate) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        tax_rate: "",
      }));
    }
  };

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
    const value = newValue ? newValue.value : "";
    setFormData((prevData) => ({
      ...prevData,
      category: value,
    }));
    if (errors.category) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        category: "",
      }));
    }
  };

  const handleBrandChange = (event, newValue) => {
    setSelectedBrand(newValue);
    const value = newValue ? newValue.value : "";
    setFormData((prevData) => ({
      ...prevData,
      brand: value,
    }));
  };

  const handleCessChange = (event, newValue) => {
    setSelectedCess(newValue);
    const value = newValue ? newValue.value : "";
    setFormData((prevData) => ({
      ...prevData,
      cess_rate: value,
    }));
  };

  const fetchUnitOptions = async () => {
    try {
      const response = await fetch(`${config.API_URL}/get_unit`, {
        method: 'POST',
        headers: { authorization: `Bearer ${accessToken}` }
      });
      const data = await response.json();
      const formattedOptions = (data.data || []).map(item => ({
        label: item.code,
        value: item.id,
      }));
      setUnitOptions(formattedOptions);
    } catch (error) {
    }
  };

  const fetchVatOptions = async () => {
    try {
      const response = await fetch(`${config.API_URL}/get_vat`, {
        method: 'POST',
        headers: { authorization: `Bearer ${accessToken}` }
      });
      const data = await response.json();
      const formattedOptions = (data.data || []).map(item => ({
        label: item.name,
        value: item.id,
      }));
      setVatOptions(formattedOptions);
    } catch (error) {
    }
  };

  const fetchBrandOptions = async () => {
    try {
      const response = await fetch(`${config.API_URL}/get_brands`, {
        method: 'POST',
        headers: { authorization: `Bearer ${accessToken}` }
      });
      const data = await response.json();
      const formattedOptions = (data.data || []).map(item => ({
        label: item.name,
        value: item.id,
      }));
      setBrandOptions(formattedOptions);
    } catch (error) {
    }
  };

  const fetchCategoryOptions = async () => {
    try {
      const response = await fetch(`${config.API_URL}/get_categories`, {
        method: 'POST',
        headers: { authorization: `Bearer ${accessToken}` }
      });
      const data = await response.json();
      const formattedOptions = (data.data || []).map(item => ({
        label: item.name,
        value: item.id,
      }));
      setCategoryOptions(formattedOptions);
    } catch (error) {
    }
  };

  const fetchCessOptions = async () => {
    try {
      const response = await fetch(`${config.API_URL}/get_cess`, {
        method: 'POST',
        headers: { authorization: `Bearer ${accessToken}` }
      });
      const data = await response.json();
      const formattedOptions = (data.data || []).map(item => ({
        label: item.name,
        value: item.id,
      }));
      setCessOptions(formattedOptions);
    } catch (error) {
    }
  };

  const getCBM = (override = {}) => {
    const cbm = computeCbmFromDimensions(
      $("#add_length").val(),
      $("#add_width").val(),
      $("#add_height").val(),
      override.lengthUnit ?? lengthUnit,
      override.widthUnit ?? widthUnit,
      override.heightUnit ?? heightUnit
    );
    $("#add_cbm").val(cbm);
  };

  useEffect(() => {
    setSelectedOption("0");
    fetchUnitOptions();
    fetchVatOptions();
    fetchBrandOptions();
    fetchCategoryOptions();
    if (showCessRate === "Y") {
      fetchCessOptions();
    }

    const applyDynamicForm = (form) => {
      const detailsSection = form?.sections?.find(
        (section) => section.id === "product_details"
      );
      const fields = detailsSection?.fields?.length
        ? detailsSection.fields
        : form?.fields || [];
      setDynamicFormMeta(form || null);
      setDynamicFields(fields);
      if (!fields.length) {
        return;
      }
      setFormData((prev) => {
        const next = { ...prev };
        fields.forEach((field) => {
          const key = resolveProductFormFieldName(field.name);
          const hasDefault =
            field.defaultValue !== undefined &&
            field.defaultValue !== null &&
            field.defaultValue !== "";
          if (hasDefault && (next[key] === undefined || next[key] === "")) {
            next[key] = field.defaultValue;
          } else if (next[key] === undefined) {
            next[key] = "";
          }
        });
        if (next.split === "" || next.split == null) {
          next.split = "0";
        }
        return next;
      });
      const modeFromForm =
        resolvePricingModeSelection(form?.pricing_type) ||
        resolvePricingModeSelection(form?.product_type) ||
        resolvePricingModeSelection(form?.split);
      const splitFromMode = PRODUCT_TYPE_TO_SPLIT[modeFromForm] || "";
      const splitDefault =
        splitFromMode ||
        fields.find((field) => field.name === "product_type")?.defaultValue ||
        "0";
      setSelectedOption(String(splitDefault));
      const lengthDefault =
        fields.find((field) => field.name === "length_unit")?.defaultValue ||
        "mm";
      const widthDefault =
        fields.find((field) => field.name === "width_unit")?.defaultValue ||
        "mm";
      const heightDefault =
        fields.find((field) => field.name === "height_unit")?.defaultValue ||
        "mm";
      setLengthUnit(String(lengthDefault).toLowerCase());
      setWidthUnit(String(widthDefault).toLowerCase());
      setHeightUnit(String(heightDefault).toLowerCase());
    };

    const supplierVisibleFromForm = (form) => {
      const groups = [
        ...(form?.sections || []).map((section) => section.fields || []),
        form?.fields || [],
      ];
      let found = false;
      let shown = true;
      const walk = (fields) => {
        (fields || []).forEach((field) => {
          const name = String(field?.name || "").toLowerCase();
          const label = String(field?.label || "").toLowerCase();
          if (name.includes("supplier") || label.includes("supplier")) {
            found = true;
            if (field.visible === false) shown = false;
          }
          if (field.fields?.length) walk(field.fields);
        });
      };
      groups.forEach((group) => walk(group));
      return found ? shown : true;
    };

    const loadDynamicForm = async () => {
      const auth = jwtToken || accessToken;
      if (!useDynamicForm) {
        setDynamicFields([]);
        setDynamicFormMeta(null);
        setDynamicOptionsBySource({});
        try {
          const form = await fetchDynamicForm({
            formKey: "add_product",
            authToken: auth,
          });
          setSelectSupplierAllowed(supplierVisibleFromForm(form));
        } catch {
          setSelectSupplierAllowed(true);
        }
        return;
      }
      try {
        const auth = jwtToken || accessToken;
        const form = await fetchDynamicForm({
          formKey: "add_product",
          authToken: auth,
        });
        applyDynamicForm(form);
        setSelectSupplierAllowed(supplierVisibleFromForm(form));
        const fields = form?.fields?.length
          ? form.fields
          : (form?.sections || []).flatMap((section) => section.fields || []);
        const optionsMap = await loadProductFormOptionsMap({
          fields,
          authToken: auth,
        });
        setDynamicOptionsBySource(optionsMap);
      } catch {
        setDynamicFields([]);
        setDynamicFormMeta(null);
        setDynamicOptionsBySource({});
      }
    };

    const fetchPriceVariation = async () => {
      try {
        const data = await postGetPriceVariation(`${config.API_URL}/get_price_variation`, jwtToken, {
          draw: 1,
          start: 0,
          length: 1,
        });

        if (data?.isAutogenProductCode === "Y" && data?.product_code) {
          setFormData((prev) => ({
            ...prev,
            code: data.product_code,
            slug: data.product_code,
          }));
          setIsReadOnly(true);
        } else {
          setIsReadOnly(false);
        }
      } catch {
      }
    };

    loadDynamicForm();
    fetchPriceVariation();
  }, []);

  useEffect(() => {
    if (!useDynamicForm || !lockedSplit || lockedSplit === "2") return;
    if (selectedOption === lockedSplit) return;
    setSelectedOption(lockedSplit);
    setFormData((prev) => ({ ...prev, split: lockedSplit }));
  }, [lockedSplit, selectedOption, useDynamicForm]);

  const fetchAndApplyPriceVariation = async (basePrice) => {
    if (!basePrice || isNaN(basePrice) || basePrice <= 0) return;
    try {
      const json = await postGetPriceVariation(`${config.API_URL}/get_price_variation`, jwtToken, {
        draw: 1,
        start: 0,
        length: 10,
      });
      const rows = Array.isArray(json?.data) ? json.data : [];
      const row = rows[0];
      if (!row) return;
      const p2 = parseFloat(row.percentage2);
      const p3 = parseFloat(row.percentage3);
      const p4 = parseFloat(row.percentage4);
      const p5 = parseFloat(row.percentage5);
      const p6 = parseFloat(row.percentage6);
      const calc = (p) => (isNaN(p) ? "" : ((basePrice * p) / 100).toFixed(2));
      setFormData((prev) => ({
        ...prev,
        price_1: calc(p2),
        price_2: calc(p3),
        price_3: calc(p4),
        price_4: calc(p5),
        price_5: calc(p6),
      }));
    } catch {
    }
  };

  const fetchAndApplyPiecePriceVariation = async (basePrice) => {
    if (!basePrice || isNaN(basePrice) || basePrice <= 0) return;
    try {
      const json = await postGetPriceVariation(`${config.API_URL}/get_price_variation`, jwtToken, {
        draw: 1,
        start: 0,
        length: 10,
      });
      const rows = Array.isArray(json?.data) ? json.data : [];
      const row = rows[0];
      if (!row) return;
      const p2 = parseFloat(row.percentage2);
      const p3 = parseFloat(row.percentage3);
      const p4 = parseFloat(row.percentage4);
      const p5 = parseFloat(row.percentage5);
      const p6 = parseFloat(row.percentage6);
      const calc = (p) => (isNaN(p) ? "" : ((basePrice * p) / 100).toFixed(2));
      setFormData((prev) => ({
        ...prev,
        piece_price1: calc(p2),
        piece_price2: calc(p3),
        piece_price3: calc(p4),
        piece_price4: calc(p5),
        piece_price5: calc(p6),
      }));
    } catch {
    }
  };

  const fetchAndApplySpecialBoxPriceVariation = async (basePrice) => {
    if (!basePrice || isNaN(basePrice) || basePrice <= 0) return;
    try {
      const json = await postGetPriceVariation(`${config.API_URL}/get_price_variation`, jwtToken, {
        draw: 1,
        start: 0,
        length: 10,
      });
      const rows = Array.isArray(json?.data) ? json.data : [];
      const row = rows[0];
      if (!row) return;
      const p2 = parseFloat(row.percentage2);
      const p3 = parseFloat(row.percentage3);
      const p4 = parseFloat(row.percentage4);
      const p5 = parseFloat(row.percentage5);
      const p6 = parseFloat(row.percentage6);
      const calc = (p) => (isNaN(p) ? "" : ((basePrice * p) / 100).toFixed(2));
      setFormData((prev) => ({
        ...prev,
        band2_special_box_price: calc(p2),
        band3_special_box_price: calc(p3),
        band4_special_box_price: calc(p4),
        band5_special_box_price: calc(p5),
        band6_special_box_price: calc(p6),
      }));
    } catch {
    }
  };

  const fetchAndApplySpecialPiecePriceVariation = async (basePrice) => {
    if (!basePrice || isNaN(basePrice) || basePrice <= 0) return;
    try {
      const json = await postGetPriceVariation(`${config.API_URL}/get_price_variation`, jwtToken, {
        draw: 1,
        start: 0,
        length: 10,
      });
      const rows = Array.isArray(json?.data) ? json.data : [];
      const row = rows[0];
      if (!row) return;
      const p2 = parseFloat(row.percentage2);
      const p3 = parseFloat(row.percentage3);
      const p4 = parseFloat(row.percentage4);
      const p5 = parseFloat(row.percentage5);
      const p6 = parseFloat(row.percentage6);
      const calc = (p) => (isNaN(p) ? "" : ((basePrice * p) / 100).toFixed(2));
      setFormData((prev) => ({
        ...prev,
        band2_special_piece_price: calc(p2),
        band3_special_piece_price: calc(p3),
        band4_special_piece_price: calc(p4),
        band5_special_piece_price: calc(p5),
        band6_special_piece_price: calc(p6),
      }));
    } catch {
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    let fieldErrors = {};

    const costValue = name === "cost" ? parseFloat(value) : parseFloat(formData.cost);
    const priceValue = name === "price" ? parseFloat(value) : parseFloat(formData.price);
    const pieceCostValue = name === "piece_cost" ? parseFloat(value) : parseFloat(formData.piece_cost);
    const splitPriceValue = name === "split_price" ? parseFloat(value) : parseFloat(formData.split_price);

    if (name === "price" || name === "cost") {
      if (priceValue > 0 && priceValue > costValue) {
        const margin = ((priceValue - costValue) / priceValue) * 100;
        setFormData({
          ...formData,
          price: name === "price" ? priceValue : formData.price,
          cost: name === "cost" ? costValue : formData.cost,
          margin: margin.toFixed(0),
        });
      } else {
        setFormData({
          ...formData,
          price: name === "price" ? priceValue : formData.price,
          cost: name === "cost" ? costValue : formData.cost,
          margin: "",
        });
      }
    }

    if (name === "split_price" || name === "piece_cost") {
      if (splitPriceValue > 0 && splitPriceValue > pieceCostValue) {
        const pieceMargin = ((splitPriceValue - pieceCostValue) / splitPriceValue) * 100;
        setFormData({
          ...formData,
          split_price: name === "split_price" ? splitPriceValue : formData.split_price,
          piece_cost: name === "piece_cost" ? pieceCostValue : formData.piece_cost,
          piece_margin: pieceMargin.toFixed(0),
        });
      } else {
        setFormData({
          ...formData,
          split_price: name === "split_price" ? splitPriceValue : formData.split_price,
          piece_cost: name === "piece_cost" ? pieceCostValue : formData.piece_cost,
          piece_margin: "",
        });
      }
    }

    if (name === "pack") {
      const numericValue = parseFloat(value);
      if (isNaN(numericValue) || numericValue < 0) {
        fieldErrors[name] = "Pack must be a positive number.";
        setFormData({ ...formData, [name]: "" });
      } else {
        fieldErrors[name] = "";
        setFormData({ ...formData, [name]: numericValue });
      }
    }

    if (name === "code") {
      const slugVal = value;
      setFormData((prevState) => ({
        ...prevState,
        slug: slugVal,
      }));
    }

    const isSelectCostBoxHidden = selectedOption == "0" || selectedOption == "2";
    const isSelectPieceBoxHidden = selectedOption == "1" || selectedOption == "2";

    switch (name) {
      case "code":
        if (!value) {
          fieldErrors.code = "Mention code.";
        } else if (value.length < 2) {
          fieldErrors.code = "code must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.code = "code must not exceed 255 characters.";
        }
        if (!fieldErrors.code) fieldErrors.code = "";
        break;
      case "name":
        if (!value) {
          fieldErrors.name = "Mention name.";
        } else if (value.length < 2) {
          fieldErrors.name = "name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.name = "name must not exceed 255 characters.";
        }
        if (!fieldErrors.name) fieldErrors.name = "";
        break;
      case "size":
        if (!value) {
          fieldErrors.size = "Mention size.";
        } else if (value.length < 2) {
          fieldErrors.size = "size must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.size = "size must not exceed 255 characters.";
        }
        if (!fieldErrors.size) fieldErrors.size = "";
        break;
      case "pack":
        if (!value) {
          fieldErrors.pack = "Mention pack.";
        } else if (value.length < 1) {
          fieldErrors.pack = "pack must consist of at least 1 digit.";
        } else if (value.length > 255) {
          fieldErrors.pack = "pack must not exceed 255 digit.";
        }
        if (!fieldErrors.pack) fieldErrors.pack = "";
        break;
      case "cost":
        if (!isSelectCostBoxHidden) break;
        if (!value) {
          fieldErrors.cost = "Mention cost.";
        } else if (value.length < 1) {
          fieldErrors.cost = "cost must consist of at least 1 digit.";
        } else if (value.length > 255) {
          fieldErrors.cost = "cost must not exceed 255 digit.";
        }
        if (!fieldErrors.cost) fieldErrors.cost = "";
        break;
      case "price":
        if (!isSelectCostBoxHidden) break;
        if (!value) {
          fieldErrors.price = "Mention price.";
        } else if (value < 0) {
          fieldErrors.price = "Mention positive.";
        }
        if (!fieldErrors.price) fieldErrors.price = "";
        break;
      case "piece_cost":
        if (!isSelectPieceBoxHidden) break;
        if (!value) {
          fieldErrors.piece_cost = "Mention cost.";
        } else if (value < 0) {
          fieldErrors.piece_cost = "Mention positive.";
        }
        if (!fieldErrors.piece_cost) fieldErrors.piece_cost = "";
        break;
      case "split_price":
        if (!isSelectPieceBoxHidden) break;
        if (!value) {
          fieldErrors.split_price = "Mention price.";
        } else if (value < 0) {
          fieldErrors.split_price = "Mention positive.";
        }
        if (!fieldErrors.split_price) fieldErrors.split_price = "";
        break;
      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      ...fieldErrors,
    }));

    if (errors[name] && !fieldErrors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const handleDynamicFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === "split") {
      setSelectedOption(String(value));
    }
    if (name === "unit") {
      setSelectedUnit(
        unitOptions.find((option) => String(option.value) === String(value)) ||
          null
      );
    }
    if (name === "tax_rate") {
      setSelectedVat(
        vatOptions.find((option) => String(option.value) === String(value)) ||
          null
      );
    }
    if (name === "brand") {
      setSelectedBrand(
        brandOptions.find((option) => String(option.value) === String(value)) ||
          null
      );
    }
    if (name === "category") {
      setSelectedCategory(
        categoryOptions.find((option) => String(option.value) === String(value)) ||
          null
      );
    }
    if (name === "length_unit") {
      setLengthUnit(String(value || "mm").toLowerCase());
    }
    if (name === "width_unit") {
      setWidthUnit(String(value || "mm").toLowerCase());
    }
    if (name === "height_unit") {
      setHeightUnit(String(value || "mm").toLowerCase());
    }
    if (name === "code") {
      setFormData((prev) => ({
        ...prev,
        code: value,
        slug: value,
      }));
    }
    handleChange(e);
    if (
      name === "length" ||
      name === "width" ||
      name === "height" ||
      name === "length_unit" ||
      name === "width_unit" ||
      name === "height_unit"
    ) {
      const nextLength = name === "length" ? value : formData.length;
      const nextWidth = name === "width" ? value : formData.width;
      const nextHeight = name === "height" ? value : formData.height;
      const nextLengthUnit =
        name === "length_unit"
          ? String(value || "mm").toLowerCase()
          : formData.length_unit || lengthUnit;
      const nextWidthUnit =
        name === "width_unit"
          ? String(value || "mm").toLowerCase()
          : formData.width_unit || widthUnit;
      const nextHeightUnit =
        name === "height_unit"
          ? String(value || "mm").toLowerCase()
          : formData.height_unit || heightUnit;
      const cbm = computeCbmFromDimensions(
        nextLength,
        nextWidth,
        nextHeight,
        nextLengthUnit,
        nextWidthUnit,
        nextHeightUnit
      );
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        cbm,
        length_unit: nextLengthUnit,
        width_unit: nextWidthUnit,
        height_unit: nextHeightUnit,
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const priceValue = parseFloat(formData.price) || 0;
    const costValue = parseFloat(formData.cost) || 0;
    const splitPriceValue = parseFloat(formData.split_price) || 0;
    const pieceCostValue = parseFloat(formData.piece_cost) || 0;

    if (name === "price" || name === "cost") {
      if (priceValue > 0 && costValue > 0 && priceValue <= costValue) {
        toast.error("Price must be greater than cost.");
      }
      if (name === "price") {
        const basePrice = parseFloat(value);
        if (!isNaN(basePrice) && basePrice > 0) fetchAndApplyPriceVariation(basePrice);
      }
    }

    if (name === "split_price" || name === "piece_cost") {
      if (splitPriceValue > 0 && pieceCostValue > 0 && splitPriceValue <= pieceCostValue) {
        toast.error("Piece price must be greater than piece cost.");
      }
      if (name === "split_price") {
        const basePrice = parseFloat(value);
        if (!isNaN(basePrice) && basePrice > 0) fetchAndApplyPiecePriceVariation(basePrice);
      }
    }

    if (name === "band1_special_box_price") {
      const basePrice = parseFloat(value);
      if (!isNaN(basePrice) && basePrice > 0) fetchAndApplySpecialBoxPriceVariation(basePrice);
    }

    if (name === "band1_special_piece_price") {
      const basePrice = parseFloat(value);
      if (!isNaN(basePrice) && basePrice > 0) fetchAndApplySpecialPiecePriceVariation(basePrice);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (hasDynamicFields) {
      const seenNames = new Set();
      const mergedFields = [];
      [...allDynamicFields, ...productDetailsFields, ...dynamicFields].forEach((field) => {
        if (!field?.name || seenNames.has(field.name)) return;
        seenNames.add(field.name);
        mergedFields.push(field);
      });
      mergedFields.forEach((field) => {
        if (!field.required || field.visible === false) return;
        const key = resolveProductFormFieldName(field.name);
        const settingsKey = resolveProductSettingsFieldName(field.name);
        if (
          key === "suppliers" ||
          settingsKey === "suppliers" ||
          String(field.name || "").toLowerCase().includes("supplier")
        ) {
          if (!field.required) return;
          const selected = document.querySelectorAll('input[name="supplier_id[]"]');
          const hasSupplier = Array.from(selected).some(
            (input) => String(input.value || "").trim() !== ""
          );
          if (!hasSupplier) {
            newErrors.suppliers = `${field.label || "Select Supplier"} is required.`;
          }
          return;
        }
        if (
          field.type === "file" ||
          key === "product_image" ||
          settingsKey === "product_image"
        ) {
          const hasImage =
            !!imagePreview ||
            !!imageName ||
            !!document.getElementById("product_image_input")?.files?.length;
          if (!hasImage) {
            newErrors.product_image = `${field.label || "Product Image"} is required.`;
          }
          return;
        }
        const value = formData[key] ?? formData[field.name];
        if (
          field.type === "checkbox" ||
          key === "new_arrival" ||
          key === "is_discount_allow" ||
          key === "featured"
        ) {
          if (value !== true && value !== 1 && value !== "1") {
            newErrors[key] = `${field.label || key} is required.`;
          }
          return;
        }
        const priceKind =
          settingsKey === "price_box" || field.name === "price_box" || field.name === "box_price"
            ? "price_box"
            : settingsKey === "special_price_box" || field.name === "special_price_box"
              ? "special_price_box"
              : settingsKey === "price_piece" || field.name === "price_piece" || field.name === "piece_price"
                ? "price_piece"
                : settingsKey === "special_price_piece" || field.name === "special_price_piece"
                  ? "special_price_piece"
                  : "";
        if (priceKind) {
          const boxMode = selectedOption === "0" || selectedOption === "2";
          const pieceMode = selectedOption === "1" || selectedOption === "2";
          const boxPriceNames = ["price", "price_1", "price_2", "price_3", "price_4", "price_5"];
          const piecePriceNames = ["split_price", "piece_price1", "piece_price2", "piece_price3", "piece_price4", "piece_price5"];
          const boxSpecialNames = [1, 2, 3, 4, 5, 6].map((band) => `band${band}_special_box_price`);
          const pieceSpecialNames = [1, 2, 3, 4, 5, 6].map((band) => `band${band}_special_piece_price`);
          let names = [];
          let bandMap = null;
          if (priceKind === "price_box" && boxMode) {
            names = boxPriceNames;
            bandMap = activeBoxSubFields;
          } else if (priceKind === "special_price_box" && boxMode) {
            names = boxSpecialNames;
            bandMap = activeBoxSubFields;
          } else if (priceKind === "price_piece" && pieceMode) {
            names = piecePriceNames;
            bandMap = activePieceSubFields;
          } else if (priceKind === "special_price_piece" && pieceMode) {
            names = pieceSpecialNames;
            bandMap = activePieceSubFields;
          }
          names.forEach((inputName, index) => {
            const bandKey = `band_${index + 1}`;
            const bandNumber = index + 1;
            const shown = !bandMap || (bandKey in bandMap && bandMap[bandKey] !== false);
            if (!shown) return;
            const priceValue = formData[inputName];
            if (priceValue === undefined || priceValue === null || String(priceValue).trim() === "") {
              const labelByKind = {
                price_box: `Price ${bandNumber}`,
                special_price_box: `Special Price ${bandNumber}`,
                price_piece: `Piece Price ${bandNumber}`,
                special_price_piece: `Special Piece Price ${bandNumber}`,
              };
              newErrors[inputName] = `${labelByKind[priceKind] || `Price ${bandNumber}`} is required.`;
            }
          });
          return;
        }
        if (
          field.type === "repeater" ||
          field.type === "relation_table" ||
          field.type === "display" ||
          (field.fields || []).length
        ) {
          return;
        }
        if (field.name === "product_type") {
          if (selectedOption === "" || selectedOption == null) {
            newErrors.split = `${field.label || "Product Type"} is required.`;
          }
          return;
        }
        const boxMode = String(selectedOption) === "0";
        const pieceMode = String(selectedOption) === "1";
        if (
          boxMode &&
          (key === "piece_cost" || settingsKey === "piece_cost" || field.name === "piece_cost")
        ) {
          return;
        }
        if (
          pieceMode &&
          (key === "cost" || settingsKey === "box_cost" || field.name === "box_cost" || field.name === "cost")
        ) {
          return;
        }
        if (value === undefined || value === null || String(value).trim() === "") {
          newErrors[key] = `${field.label || key} is required.`;
        }
      });

      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) return true;
      return newErrors;
    }

    if (!formData.code) {
      newErrors.code = "Mention code.";
    } else if (formData.code.length < 2) {
      newErrors.code = "code must consist of at least 2 characters.";
    } else if (formData.code.length > 255) {
      newErrors.code = "code must not exceed 255 characters.";
    }

    if (!formData.name) {
      newErrors.name = "Mention name.";
    } else if (formData.name.length < 2) {
      newErrors.name = "name must consist of at least 2 characters.";
    } else if (formData.name.length > 255) {
      newErrors.name = "name must not exceed 255 characters.";
    }

    if (!formData.pack) {
      newErrors.pack = "Mention pack.";
    }

    const isSelectCostBoxHidden = selectedOption == "0" || selectedOption == "2";
    if (isSelectCostBoxHidden) {
      if (!formData.cost) newErrors.cost = "Mention cost.";
      if (!formData.price) newErrors.price = "Mention price.";
      if (!formData.price_1) newErrors.price_1 = "Mention price.";
      if (!formData.price_2) newErrors.price_2 = "Mention price.";
      if (!formData.price_3) newErrors.price_3 = "Mention price.";
      if (!formData.price_4) newErrors.price_4 = "Mention price.";
      if (!formData.price_5) newErrors.price_5 = "Mention price.";
    }

    const isSelectPieceBoxHidden = selectedOption == "1" || selectedOption == "2";
    if (isSelectPieceBoxHidden) {
      if (!formData.piece_cost) newErrors.piece_cost = "Mention cost.";
      if (!formData.split_price) newErrors.split_price = "Mention price.";
      if (!formData.piece_price1) newErrors.piece_price1 = "Mention price.";
      if (!formData.piece_price2) newErrors.piece_price2 = "Mention price.";
      if (!formData.piece_price3) newErrors.piece_price3 = "Mention price.";
      if (!formData.piece_price4) newErrors.piece_price4 = "Mention price.";
      if (!formData.piece_price5) newErrors.piece_price5 = "Mention price.";
    }

    if (!formData.size || formData.size === "0") newErrors.size = "Size is required.";
    if (!formData.unit || formData.unit === "0") newErrors.unit = "Unit is required.";
    if (!formData.tax_rate || formData.tax_rate === "0") newErrors.tax_rate = "VAT is required.";
    if (!formData.category || formData.category === "0") newErrors.category = "Category is required.";

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) return true;
    return newErrors;
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitProductForm = async (event) => {
    event.preventDefault();
    const validation = validateForm();
    if (validation !== true) {
      const message = Object.values(validation).filter(Boolean).join(", ");
      toast.error(message || "Please fill the required fields");
      return;
    }
    const form = document.getElementById("addproductform");
    setIsSubmitting(true);
    let cbm = $("#add_cbm").val();
    const formDataObj = new FormData(form);
    formDataObj.set("cbm", cbm);
    formDataObj.set("length_unit", lengthUnit);
    formDataObj.set("width_unit", widthUnit);
    formDataObj.set("height_unit", heightUnit);
    formDataObj.set("unit", formData.unit || "");
    formDataObj.set("tax_rate", formData.tax_rate || "");
    formDataObj.set("category", formData.category || "");
    formDataObj.set("brand", formData.brand || "");
    formDataObj.set("is_discount_allow", formData.is_discount_allow === "1" ? "1" : "0");
    formDataObj.set("new_arrival", formData.new_arrival === "1" ? "1" : "0");
    formDataObj.set("featured", formData.featured === "1" ? "1" : "0");
    formDataObj.set("availableFor", formData.availableFor === "1" ? "1" : "0");
    if (showCessRate === "Y") {
      formDataObj.set("cess_rate", formData.cess_rate || "");
    }
    formDataObj.set("maximum_order_quantity", formData.maximum_order_quantity ?? "");
    let useEncrypt = false;
    try {
      const settings = await getCompanySettings();
      useEncrypt = resolveCustomerApiEncrypt(settings);
      let uploadBody;
      if (useEncrypt) {
        const plain = plainObjectFromFormData(formDataObj);
        const encryptedPayload = encryptPayload(plain);
        if (!encryptedPayload) {
          toast.error("Encryption key missing.");
          setIsSubmitting(false);
          return;
        }
        uploadBody = new FormData();
        uploadBody.append("encrypted_payload", encryptedPayload);
        const imgInput = document.getElementById("product_image_input");
        if (imgInput && imgInput.files && imgInput.files[0]) {
          uploadBody.append("product_image", imgInput.files[0]);
        }
      } else {
        uploadBody = formDataObj;
      }
      const response = await axios.post(`${config.API_URL}/add_products`, uploadBody, {
        headers: {
          authorization: `Bearer ${jwtToken}`,
        },
      });
      const result = normalizeEncryptedApiResponse(response.data, useEncrypt);
      const msg = result.message;
      if (result.success == true) {
        toast.success("Product added successfully.");
        if (isAtrPrefix) {
          setQbPromptOpen(true);
        } else {
          setTimeout(() => {
            window.location.href = config.BASE_URL + "/products/";
          }, 1500);
        }
      } else {
        toast.error(msg || "Failed to add product.");

      }
    } catch (error) {
      const rawErr = error.response?.data;
      const errBody = normalizeEncryptedApiResponse(rawErr, useEncrypt);
      const errMsg = errBody?.message ?? rawErr?.message;
      if (error.response?.status === 409) {
        toast.error(errMsg || "Product code already present.");
      } else {
        toast.error(errMsg || "Failed to add product.");
      }
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const [imageName, setImageName] = useState("");
  const [imagePreview, setImagePreview] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageName(file.name);
      setImagePreview(URL.createObjectURL(file));
      if (errors.product_image) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          product_image: "",
        }));
      }
    }
  };

  const handleRemoveImage = () => {
    setImageName("");
    setImagePreview("");
    document.getElementById("product_image_input").value = "";
  };

  const acceptNumber = (event) => {
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, "");
    if (value.indexOf(".") !== -1) {
      const parts = value.split(".");
      value = parts[0] + "." + parts[1].substring(0, 2);
    }
    event.target.value = value;
  };

  return (
    <>
      <Box className="page-container">
        <Paper className="paper-style" elevation={0} sx={{ px: 2, py: 1 }}>
          <Box>
            <Typography className="page-title">
              {useDynamicForm ? "Add Product (Dynamic)" : "Add Product"}
            </Typography>
          </Box>
          <Typography sx={{ fontWeight: 500, mb: 2, fontSize: '10px' }} >
            Note : Fields marked with a red asterisk (*) are mandatory
          </Typography>
          <form id="addproductform">
            <input type="hidden" value={userId} name="user_id" />
            <input type="hidden" value={formData.unit} name="unit" />
            <input type="hidden" value={formData.tax_rate} name="tax_rate" />
            <input type="hidden" value={formData.category} name="category" />
            <input type="hidden" value={formData.brand} name="brand" />
            {showCessRate === "Y" && <input type="hidden" value={formData.cess_rate} name="cess_rate" />}
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                {hasDynamicFields ? (
                  <>
                    <DynamicProductFormFields
                      fields={productDetailsFields}
                      formData={formData}
                      errors={errors}
                      onChange={handleDynamicFieldChange}
                      isReadOnly={isReadOnly}
                      optionsBySource={optionsBySource}
                    />
                    <input type="hidden" value={formData.slug} name="slug" />
                    <input type="hidden" value={formData.length_unit || lengthUnit} name="length_unit" />
                    <input type="hidden" value={formData.width_unit || widthUnit} name="width_unit" />
                    <input type="hidden" value={formData.height_unit || heightUnit} name="height_unit" />
                    {hasDynField("product_image") && (
                    <Grid2 container spacing={2} sx={{ mt: 1.2 }}>
                      <Grid2 size={{ xs: 12, sm: 6 }}>
                        <Typography className="productForm-lables">
                          Product Image
                          {findDynField("product_image")?.required ? (
                            <span style={{ color: "red" }}> *</span>
                          ) : null}
                        </Typography>
                        <Box
                          sx={{
                            border: errors.product_image
                              ? "1px dashed #d32f2f"
                              : "1px dashed rgba(27, 27, 27, 0.53)",
                            borderRadius: 1,
                            p: 1,
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                          onClick={() => document.getElementById('product_image_input').click()}
                        >
                          <input
                            type="file"
                            id="product_image_input"
                            name="product_image"
                            accept="image/png, image/jpeg"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                          />
                          <Iconify icon="mdi:cloud-upload-outline" width={32} sx={{ color: 'text.secondary' }} />
                          <Typography>Click to upload</Typography>
                          <Typography variant="caption">PNG, JPG</Typography>
                        </Box>
                        {errors.product_image ? (
                          <Typography variant="caption" sx={{ color: "error.main" }}>
                            {errors.product_image}
                          </Typography>
                        ) : null}
                        {imagePreview && (
                          <Box sx={{ mt: 2, position: "relative", width: "fit-content" }}>
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{ width: 100, borderRadius: 8, border: "1px solid rgba(145, 158, 171, 0.16)" }}
                            />
                            <IconButton
                              size="small"
                              onClick={handleRemoveImage}
                              sx={{ position: "absolute", top: -8, right: -8, width: 22, height: 22, bgcolor: "error.main", color: "#fff", '&:hover': { bgcolor: "error.dark" } }}
                            >
                              <Iconify icon="mdi:close" width={14} />
                            </IconButton>
                          </Box>
                        )}
                      </Grid2>
                    </Grid2>
                    )}
                  </>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', md: 'row' },
                      gap: 1,
                      mb: 1.5,
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        maxWidth: { xs: '100%', md: '30%' },
                      }}
                    >
                      <FormLabel className="productForm-lables">
                        Product Code <span style={{ color: 'red' }}>*</span>
                      </FormLabel>

                      <TextField
                        fullWidth
                        size="small"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        inputProps={{ maxLength: 10, readOnly: isReadOnly }}
                        error={!!errors.code}
                        helperText={errors.code}
                        className="form-input-border"
                      />
                    </Box>

                    <Box sx={{ flex: 2 }}>
                      <FormLabel className="productForm-lables">
                        Product Name <span style={{ color: 'red' }}>*</span>
                      </FormLabel>

                      <TextField
                        fullWidth
                        size="small"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        error={!!errors.name}
                        helperText={errors.name}
                        className="form-input-border"
                      />
                    </Box>
                  </Box>
                )}

                {!hasDynamicFields && !dynamicFormKeys.has("details") && (
                <Box sx={{ mb:1.5}}>
                  <Typography className="productForm-lables">Product Details</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="details"
                    value={formData.details}
                    onChange={handleChange}
                    multiline
                    rows={2}
                    className="form-input-border"
                  />
                  <input type="hidden" value={formData.slug} name="slug" />
                </Box>
                )}

                {!hasDynamicFields && (!dynamicFormKeys.has("size") || !dynamicFormKeys.has("pack")) && (
                <Box sx={{ display: 'flex', gap: 1, mb:1.5}}>
                  {!dynamicFormKeys.has("size") && (
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">
                      Size <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name="size"
                      value={formData.size}
                      onChange={handleChange}
                      error={!!errors.size}
                      helperText={errors.size}
                      className="form-input-border"
                    />
                  </Box>
                  )}
                  {!dynamicFormKeys.has("pack") && (
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">
                      Pack <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="pack"
                      value={formData.pack}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      error={!!errors.pack}
                      helperText={errors.pack}
                      className="form-input-border"
                    />
                  </Box>
                  )}
                </Box>
                )}

                {!hasDynamicFields && (
                <>
                <Box sx={{ display: 'flex', gap: 1, mb:1.5, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">
                      Unit <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Autocomplete
                      size="small"
                      options={unitOptions}
                      value={selectedUnit}
                      onChange={handleUnitChange}
                      getOptionLabel={(option) => option.label || ''}
                      renderInput={(params) => (
                        <TextField
                          className="form-input-border"
                          {...params} placeholder="Select Unit" />
                      )}
                    />
                    {errors.unit && <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>{errors.unit}</Typography>}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">
                      {company_tax_type} <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Autocomplete
                      size="small"
                      options={vatOptions}
                      value={selectedVat}
                      onChange={handleVatChange}
                      getOptionLabel={(option) => option.label || ''}
                      renderInput={(params) => (
                        <TextField
                          className="form-input-border"
                          {...params} placeholder="Select VAT" />
                      )}
                    />
                    {errors.tax_rate && <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>{errors.tax_rate}</Typography>}
                  </Box>
                </Box>

                {showCessRate === "Y" && (
                  <Box sx={{ display: 'flex', gap: 1, mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                    <Box sx={{ flex: 1 }}>
                      <Typography className="productForm-lables">CESS</Typography>
                      <Autocomplete
                        size="small"
                        options={cessOptions}
                        value={selectedCess}
                        onChange={handleCessChange}
                        getOptionLabel={(option) => option.label || ''}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select CESS" />
                        )}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography className="productForm-lables">HSN Code</Typography>
                      <TextField
                        fullWidth
                        size="small"
                        name="hsn_code"
                        value={formData.hsn_code}
                        onChange={handleChange}
                        className="form-input-border"
                      />
                    </Box>
                  </Box>
                )}

                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">Min Qty</Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="min_alert_quantity"
                      value={formData.min_alert_quantity}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      className="form-input-border"
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">Max Qty</Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="max_alert_quantity"
                      value={formData.max_alert_quantity}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      className="form-input-border"
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">Maximum Order Qty</Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="maximum_order_quantity"
                      value={formData.maximum_order_quantity}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      className="form-input-border"
                    />
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">Brand</Typography>
                    <Autocomplete
                      size="small"
                      options={brandOptions}
                      value={selectedBrand}
                      onChange={handleBrandChange}
                      getOptionLabel={(option) => option.label || ''}
                      renderInput={(params) => (
                        <TextField
                          className="form-input-border"
                          {...params} placeholder="Select Brand" />
                      )}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography className="productForm-lables">
                      Category <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Autocomplete
                      size="small"
                      options={categoryOptions}
                      value={selectedCategory}
                      onChange={handleCategoryChange}
                      getOptionLabel={(option) => option.label || ''}
                      renderInput={(params) => (
                        <TextField
                          className="form-input-border"
                          {...params} placeholder="Select Category" />
                      )}
                    />
                    {errors.category && <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>{errors.category}</Typography>}
                  </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Grid2 container spacing={1} sx={{ mb: 1 }}>
                    <Grid2 size={{ xs: 12, sm: 6 }}>
                      <Box sx={{ display: "flex", gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <TextField
                          label="Length"
                          size="small"
                          name="length"
                          id="add_length"
                          onChange={(e) => { getCBM(); acceptNumber(e); }}
                          sx={{
                            flex: 1,
                          }}
                          className="form-input-border text-field"
                          fullWidth
                        />
                        <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 75 } }}>
                          <Select
                            className="input-border"
                            name="length_unit"
                            id="length_unit"
                            value={lengthUnit}
                            onChange={(e) => {
                              const v = e.target.value;
                              setLengthUnit(v);
                              getCBM({ lengthUnit: v });
                            }}
                            sx={{ fontSize: 13, height:35}}
                          >
                            <MenuItem value="mm">MM</MenuItem>
                            <MenuItem value="cm">CM</MenuItem>
                            <MenuItem value="in">IN</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6 }}>
                      <Box sx={{ display: "flex", gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <TextField

                          label="Width"
                          className="form-input-border text-field"
                          size="small"
                          name="width"
                          id="add_width"
                          onChange={(e) => { getCBM(); acceptNumber(e); }}
                          sx={{
                            flex: 1,
                          }}
                          fullWidth
                        />
                        <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 75 } }}>
                          <Select
                            className="input-border"
                            name="width_unit"
                            id="width_unit"
                            value={widthUnit}
                            onChange={(e) => {
                              const v = e.target.value;
                              setWidthUnit(v);
                              getCBM({ widthUnit: v });
                            }}
                            sx={{ fontSize: 13, height:35}}
                          >
                            <MenuItem value="mm">MM</MenuItem>
                            <MenuItem value="cm">CM</MenuItem>
                            <MenuItem value="in">IN</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid2>
                  </Grid2>
                  <Grid2 container spacing={1}>
                    <Grid2 size={{ xs: 12, sm: 6 }}>
                      <Box sx={{ display: "flex", gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <TextField
                          label="Height"
                          size="small"
                          name="height"
                          id="add_height"
                          onChange={(e) => { getCBM(); acceptNumber(e); }}
                          className="form-input-border text-field"
                          sx={{ flex: 1 }}
                          fullWidth
                        />
                        <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 75 } }}>
                          <Select
                            className="input-border"
                            size="small"
                            name="height_unit"
                            id="height_unit"
                            value={heightUnit}
                            onChange={(e) => {
                              const v = e.target.value;
                              setHeightUnit(v);
                              getCBM({ heightUnit: v });
                            }}
                            sx={{ fontSize: 13, height:35}}
                          >
                            <MenuItem value="mm">MM</MenuItem>
                            <MenuItem value="cm">CM</MenuItem>
                            <MenuItem value="in">IN</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid2>
                  </Grid2>
                </Box>

                <Grid2 container spacing={1} sx={{ mb: 2 }}>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField label="CBM" className="form-input-border text-field" fullWidth size="small" name="cbm" id="add_cbm" disabled />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField label="Gross Weight" fullWidth size="small" name="gross_weight" onChange={acceptNumber} placeholder="kg"
                      className="form-input-border text-field"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField label="Net Weight" className="form-input-border text-field" fullWidth size="small" name="net_weight" onChange={acceptNumber} placeholder="kg"
                    />
                  </Grid2>
                </Grid2>

                <Grid2 container spacing={1} sx={{ mb: 2 }}>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <TextField label="Bay" className="form-input-border text-field" fullWidth size="small" name="bay" value={formData.bay} onChange={handleChange}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <TextField label="Rack" className="form-input-border text-field" fullWidth size="small" name="rack" value={formData.rack} onChange={handleChange}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <TextField label="Part Number" className="form-input-border text-field" fullWidth size="small" name="part_number" value={formData.part_number} onChange={handleChange}
                    />
                  </Grid2>
                </Grid2>

                <Grid2 container spacing={1} sx={{ mb: 2 }}>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField label="Inner EAN" className="form-input-border text-field" fullWidth size="small" name="inner_ean_number" value={formData.inner_ean_number} onChange={handleChange} />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField label="Outer EAN" className="form-input-border text-field" fullWidth size="small" name="outer_ean_number" value={formData.outer_ean_number} onChange={handleChange} />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField label="Pallet EAN" className="form-input-border text-field" fullWidth size="small" name="pallete_ean" value={formData.pallete_ean} onChange={handleChange} />
                  </Grid2>
                </Grid2>

                <Grid2 container spacing={1} sx={{ mb: 2 }}>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className="checkBox"
                          size="small"
                          name="new_arrival"
                          checked={formData.new_arrival === "1"}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="New Arrival"
                    />
                    {formData.new_arrival === "1" && (
                      <Box sx={{ mt: 0.5 }}>
                        <Typography className="productForm-lables">Arrival Ends On</Typography>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            className="input-border"
                            value={formData.new_arrival_date ? new Date(formData.new_arrival_date) : null}
                            onChange={(newValue) => {
                              const dateStr = newValue ? format(newValue, 'yyyy-MM-dd') : '';
                              setFormData((prevData) => ({
                                ...prevData,
                                new_arrival_date: dateStr,
                              }));
                            }}
                            slotProps={{
                              textField: {
                                size: 'small',
                                fullWidth: true,
                                name: 'new_arrival_date',
                              }
                            }}
                          />
                        </LocalizationProvider>
                      </Box>
                    )}
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className="checkBox"
                          size="small"
                          name="is_discount_allow"
                          checked={formData.is_discount_allow === "1"}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Discount Product"
                    />
                    {formData.is_discount_allow === "1" && (
                      <Box sx={{ mt: 0.5 }}>
                        <Typography className="productForm-lables">Discount %</Typography>
                        <TextField
                          className="input-border"
                          fullWidth
                          size="small"
                          type="number"
                          name="percentage"
                          value={formData.percentage}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                        />
                      </Box>
                    )}
                  </Grid2>
                </Grid2>

                <Grid2 container spacing={2} sx={{ mt: 1.2 }}>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography className="productForm-lables">Product Image</Typography>
                    <Box
                      sx={{
                        border: '1px dashed rgba(27, 27, 27, 0.53)',
                        borderRadius: 1,
                        p: 1,
                        textAlign: 'center',
                        cursor: 'pointer',
                        transition: 'border-color 0.2s',

                      }}
                      onClick={() => document.getElementById('product_image_input').click()}
                    >
                      <input
                        type="file"
                        id="product_image_input"
                        name="product_image"
                        accept="image/png, image/jpeg"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                      />
                      <Iconify icon="mdi:cloud-upload-outline" width={32} sx={{ color: 'text.secondary' }} />
                      <Typography >Click to upload</Typography>
                      <Typography variant="caption">PNG, JPG</Typography>
                    </Box>
                    {imagePreview && (
                      <Box sx={{ mt: 2, position: "relative", width: "fit-content" }}>
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ width: 100, borderRadius: 8, border: "1px solid rgba(145, 158, 171, 0.16)" }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{ position: "absolute", top: -8, right: -8, width: 22, height: 22, bgcolor: "error.main", color: "#fff", '&:hover': { bgcolor: "error.dark" } }}
                        >
                          <Iconify icon="mdi:close" width={14} />
                        </IconButton>
                      </Box>
                    )}
                  </Grid2>
                  <Grid2 size={6} display="flex" gap={1} flexDirection="column">
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            className="checkBox"
                            size="small"
                            name="featured"
                            checked={formData.featured === "1"}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Featured (Shop homepage listing)"
                      />
                    </Box>
                    <Box>
                      <Typography className="productForm-lables">Available For</Typography>
                      <Select
                        className="input-border"
                        fullWidth
                        placeholder="Select Available For"
                        size="small"
                        name="availableFor"
                        value={formData.availableFor === "1" ? "1" : "0"}
                        onChange={handleChange}
                      >
                        <MenuItem value="0">All</MenuItem>
                        <MenuItem value="1">TeleCaller</MenuItem>
                      </Select>
                    </Box>
                  </Grid2>
                </Grid2>
                </>
                )}
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                {(!hasDynamicFields || hasDynField("product_type")) && (
                <Box sx={{ mb:1}}>
                  <FormControl>
                    <RadioGroup
                      row
                      name="split"
                      value={selectedOption}
                      onChange={(e) => toggleOptions(e.target.value)}
                    >
                      {showBoxTypeOption && (
                      <FormControlLabel value="0" control={<Radio size="small" className="checkBox" />} label="Box" />
                      )}
                      {showPieceTypeOption && (
                      <FormControlLabel value="1" control={<Radio size="small" className="checkBox" />} label="Piece" />
                      )}
                      {showBothTypeOption && (
                      <FormControlLabel value="2" control={<Radio size="small" className="checkBox" />} label="Both" />
                      )}
                    </RadioGroup>
                  </FormControl>
                </Box>
                )}

                {showBoxPricing && (
                  <Paper variant="outlined" sx={{ px: 2, py: 1, borderRadius: 1, borderColor: 'rgba(59, 60, 61, 0.2)', mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1.5, pb: 0.5, borderBottom: '1px solid rgba(53, 53, 53, 0.48)', fontWeight: 600, fontSize: '14px' }}>
                      Box Pricing
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                      {(!hasDynamicFields || hasDynField("box_cost") || hasDynField("cost")) &&
                        (!useDynamicForm || activeBoxSubFields?.box_cost !== false) && (
                      <Box sx={{ flex: 1 }}>
                        <TextField
                          className="input-border text-field"
                          fullWidth
                          required
                          label="Box Cost"
                          size="small"
                          type="number"
                          name="cost"
                          value={formData.cost}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onWheel={(e) => e.target.blur()}
                          error={!!errors.cost}
                          helperText={errors.cost}
                          sx={{
                            '& .MuiFormLabel-asterisk': {
                              color: 'red',
                            },
                          }}
                        />
                      </Box>
                      )}
                      {(!hasDynamicFields || hasDynField("recommended_selling_price") || hasDynField("recommendedSellingBoxPrice")) &&
                        (!useDynamicForm || activeBoxSubFields?.recommended_selling_price !== false) && (
                      <Box sx={{ flex: 1 }}>
                        <TextField
                          className="input-border text-field"
                          fullWidth
                          required
                          size="small"
                          label="Recommended Selling Price"
                          type="number"
                          name="recommendedSellingBoxPrice"
                          value={formData.recommendedSellingBoxPrice}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                          sx={{
                            '& .MuiFormLabel-asterisk': {
                              color: 'red',
                            },
                          }}
                        />
                      </Box>
                      )}
                    </Box>

                    {(!hasDynamicFields ||
                      hasDynField("box_prices") ||
                      hasDynField("price_box") ||
                      hasDynField("special_price_box")) && (
                    <BoxPricingTable
                      formData={formData}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      errors={errors}
                      selectedOption={selectedOption}
                      accessToken={accessToken}
                      visibleSubFields={useDynamicForm ? activeBoxSubFields : null}
                    />
                    )}

                    {(!useDynamicForm || activeBoxSubFields?.box_margin !== false) && (
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                      <Box sx={{ flex: 1, maxWidth: '50%' }}>
                        <Typography className="productForm-lables">
                          Box Margin(%)
                          {(findDynField("box_margin") || findDynField("margin"))?.required ? (
                            <span style={{ color: "red" }}> *</span>
                          ) : null}
                        </Typography>
                        <TextField
                          className="input-border"
                          fullWidth
                          size="small"
                          type="number"
                          name="margin"
                          value={formData.margin}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                          error={!!errors.margin}
                          helperText={errors.margin || ""}
                          InputProps={useDynamicForm ? undefined : { readOnly: true }}
                        />
                      </Box>
                    </Box>
                    )}
                  </Paper>
                )}

                {showPiecePricing && (
                  <Paper variant="outlined" sx={{ px: 2, py: 1, borderRadius: 1, mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1.5, pb: 0.5, borderBottom: '1px solid rgba(53, 53, 53, 0.48)', fontWeight: 600, fontSize: '14px' }}>
                      Piece Pricing
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                      {(!hasDynamicFields || hasDynField("piece_cost")) &&
                        (!useDynamicForm || activePieceSubFields?.piece_cost !== false) && (
                      <Box sx={{ flex: 1 }}>
                        <Typography className="productForm-lables">
                          Piece Cost
                          {(!useDynamicForm || findDynField("piece_cost")?.required) ? (
                            <span style={{ color: "red" }}> *</span>
                          ) : null}
                        </Typography>
                        <TextField
                          className="input-border"
                          fullWidth
                          size="small"
                          type="number"
                          name="piece_cost"
                          value={formData.piece_cost}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onWheel={(e) => e.target.blur()}
                          error={!!errors.piece_cost}
                          helperText={errors.piece_cost}
                        />
                      </Box>
                      )}
                      {(!hasDynamicFields || hasDynField("piece_recommended_selling_price") || hasDynField("recommendedSellingPiecePrice")) &&
                        (!useDynamicForm || activePieceSubFields?.piece_recommended_selling_price !== false) && (
                      <Box sx={{ flex: 1 }}>
                        <Typography className="productForm-lables">Recommended Selling Price (Piece)</Typography>
                        <TextField
                          fullWidth
                          className="input-border"
                          size="small"
                          type="number"
                          name="recommendedSellingPiecePrice"
                          value={formData.recommendedSellingPiecePrice}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                        />
                      </Box>
                      )}
                    </Box>

                    {(!hasDynamicFields ||
                      hasDynField("piece_prices") ||
                      hasDynField("price_piece") ||
                      hasDynField("special_price_piece")) &&
                      selectedOption == "1" && (
                      <PiecePricingTable
                        formData={formData}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        errors={errors}
                        accessToken={accessToken}
                        visibleSubFields={useDynamicForm ? activePieceSubFields : null}
                      />
                    )}

                    {(!useDynamicForm || activePieceSubFields?.piece_margin !== false) && (
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                      <Box sx={{ flex: 1, maxWidth: '50%' }}>
                        <Typography sx={{ color: '#637381', fontSize: '13px', mb: 0.5, fontWeight: 500 }}>Piece Margin(%)</Typography>
                        <TextField
                          className="input-border"
                          fullWidth
                          size="small"
                          type="number"
                          name="piece_margin"
                          value={formData.piece_margin}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                          InputProps={{ readOnly: true }}
                        />
                      </Box>
                    </Box>
                    )}
                  </Paper>
                )}

                {showSelectSupplier && (
                <Box sx={{ mb: 3 }}>
                  <Typography className="productForm-lables">
                    Select Supplier
                    {findDynField("suppliers")?.required ? (
                      <span style={{ color: "red" }}> *</span>
                    ) : null}
                  </Typography>
                  <Box sx={{ maxHeight: 220, overflowY: "auto", border: errors.suppliers ? "1px solid #d32f2f" : "1px solid rgba(59, 60, 61, 0.2)", borderRadius: 1, p: 1 }}>
                    <SupplierSuggestionList />
                  </Box>
                  {errors.suppliers ? (
                    <Typography variant="caption" sx={{ color: "error.main" }}>
                      {errors.suppliers}
                    </Typography>
                  ) : null}
                </Box>
                )}
              </Grid2>
            </Grid2>

            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Button
                variant="contained"
                className="button-variant-contained"
                onClick={submitProductForm}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Adding...' : 'Add Product'}
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
      <QuickBooksPushPrompt
        open={qbPromptOpen}
        pushPath="products"
        onDone={() => {
          setQbPromptOpen(false);
          window.location.href = config.BASE_URL + "/products/";
        }}
      />
    </>
  );
};

export default Add_Products;
